var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.gift.item === 'coin' ||
    _vm.gift.item === 'ticket' ||
    _vm.gift.item === 'ad_ticket'
  )?_c('icon-badge',{attrs:{"itemType":_vm.gift.item}}):_c('inbox-thumb',{attrs:{"imageUrl":_vm.gift.imageUrl,"title":_vm.gift.title}})}
var staticRenderFns = []

export { render, staticRenderFns }